import React, { useState } from "react";
import { Zap, Box, Globe, Users, Target, Search } from "react-feather";
import DetailModal from "./DetailModal";

const MarketPosition = () => {
  const [selectedHeatMapItem, setSelectedHeatMapItem] = useState(null);
  const [selectedDetailModal, setSelectedDetailModal] = useState(null);

  const heatMapData = {
    technologies: [
      {
        name: "Smart Joint Replacement Implants",
        players: 4,
        companies: [
          "Stryker",
          "Johnson & Johnson MedTech",
          "Zimmer Biomet",
          "Smith & Nephew",
        ],
        color: "custom-danger",
        marketSize: "$20.9B",
        dataKey: "tech-0",
      },
      {
        name: "Surgical Robotics Platforms",
        players: 3,
        companies: ["Stryker", "Zimmer Biomet", "Smith & Nephew"],
        color: "custom-info",
        marketSize: "$11.1B",
        dataKey: "tech-1",
      },
      {
        name: "Spine Navigation & Fusion Systems",
        players: 3,
        companies: ["Stryker", "Johnson & Johnson MedTech", "Zimmer Biomet"],
        color: "custom-info",
        marketSize: "$11.2B",
        dataKey: "tech-2",
      },
      {
        name: "Neurovascular Intervention Systems",
        players: 2,
        companies: ["Stryker", "Johnson & Johnson MedTech"],
        color: "custom-warning",
        marketSize: "$4.6B",
        dataKey: "tech-3",
        note: "Two-player leadership field",
      },
      {
        name: "Sports Medicine & Arthroscopy Platforms",
        players: 4,
        companies: [
          "Stryker",
          "Smith & Nephew",
          "Arthrex",
          "Johnson & Johnson MedTech",
        ],
        color: "custom-danger",
        marketSize: "$6.8B",
        dataKey: "tech-4",
      },
    ],
    applications: [
      {
        name: "Joint Replacement Devices",
        players: 4,
        companies: [
          "Stryker",
          "Johnson & Johnson MedTech",
          "Zimmer Biomet",
          "Smith & Nephew",
        ],
        color: "custom-danger",
        marketSize: "$23.4B",
        dataKey: "app-0",
      },
      {
        name: "Total Knee Replacement Surgery",
        players: 3,
        companies: ["Stryker", "Zimmer Biomet", "Johnson & Johnson MedTech"],
        color: "custom-info",
        marketSize: "$12.0B",
        dataKey: "app-1",
      },
      {
        name: "Spine Surgery Devices",
        players: 3,
        companies: ["Stryker", "Johnson & Johnson MedTech", "Zimmer Biomet"],
        color: "custom-info",
        marketSize: "$11.2B",
        dataKey: "app-2",
      },
      {
        name: "Trauma Fixation Systems",
        players: 4,
        companies: [
          "Stryker",
          "Johnson & Johnson MedTech",
          "Zimmer Biomet",
          "Smith & Nephew",
        ],
        color: "custom-danger",
        marketSize: "$7.6B",
        dataKey: "app-3",
      },
      {
        name: "Sports Medicine & Soft-Tissue Repair",
        players: 4,
        companies: [
          "Stryker",
          "Smith & Nephew",
          "Arthrex",
          "Johnson & Johnson MedTech",
        ],
        color: "custom-danger",
        marketSize: "$6.8B",
        dataKey: "app-4",
      },
      {
        name: "Neurovascular Stroke Intervention",
        players: 2,
        companies: ["Stryker", "Johnson & Johnson MedTech"],
        color: "custom-warning",
        marketSize: "$4.6B",
        dataKey: "app-5",
        note: "High-margin flow-diverter window",
      },
    ],
    geographies: [
      {
        name: "North America Biomaterials Demand",
        players: 4,
        companies: [
          "Stryker",
          "Johnson & Johnson MedTech",
          "Zimmer Biomet",
          "Smith & Nephew",
        ],
        color: "custom-danger",
        marketSize: "$18.2B",
        dataKey: "geo-0",
        note: "40.2% of global biomaterials spend",
      },
      {
        name: "Europe Biomaterials Demand",
        players: 4,
        companies: [
          "Stryker",
          "Johnson & Johnson MedTech",
          "Zimmer Biomet",
          "Smith & Nephew",
        ],
        color: "custom-danger",
        marketSize: "$14.2B",
        dataKey: "geo-1",
      },
      {
        name: "Asia Pacific Biomaterials Demand",
        players: 3,
        companies: ["Stryker", "Johnson & Johnson MedTech", "Zimmer Biomet"],
        color: "custom-info",
        marketSize: "$9.7B",
        dataKey: "geo-2",
        note: "Fastest-growing (>5.8% CAGR)",
      },
      {
        name: "LatAm & MEA Biomaterials Demand",
        players: 2,
        companies: ["Stryker", "Johnson & Johnson MedTech"],
        color: "custom-warning",
        marketSize: "$3.1B",
        dataKey: "geo-3",
        note: "Channel build & distributor leverage",
      },
    ],
    segments: [
      {
        name: "Hospitals & IDNs",
        players: 4,
        companies: [
          "Stryker",
          "Johnson & Johnson MedTech",
          "Zimmer Biomet",
          "Smith & Nephew",
        ],
        color: "custom-danger",
        marketSize: "$29.2B",
        dataKey: "seg-0",
      },
      {
        name: "Ambulatory Surgery Centers",
        players: 4,
        companies: [
          "Stryker",
          "Zimmer Biomet",
          "Smith & Nephew",
          "Arthrex",
        ],
        color: "custom-danger",
        marketSize: "$7.2B",
        dataKey: "seg-1",
      },
      {
        name: "Orthopedic & Sports Clinics",
        players: 3,
        companies: ["Stryker", "Smith & Nephew", "Arthrex"],
        color: "custom-info",
        marketSize: "$6.8B",
        dataKey: "seg-2",
      },
      {
        name: "Neurovascular Stroke Centers",
        players: 2,
        companies: ["Stryker", "Johnson & Johnson MedTech"],
        color: "custom-warning",
        marketSize: "$4.6B",
        dataKey: "seg-3",
        note: "Two-player GREEN OCEAN",
      },
      {
        name: "Trauma Networks & Level I Centers",
        players: 4,
        companies: [
          "Stryker",
          "Johnson & Johnson MedTech",
          "Zimmer Biomet",
          "Smith & Nephew",
        ],
        color: "custom-danger",
        marketSize: "$7.6B",
        dataKey: "seg-4",
      },
    ],
  };

  const focusAreas = {
    stryker: {
      technologies: [
        "Mako Smart Robotics",
        "Tritanium & Insignia Implants",
        "Gamma4/T2 Advance Trauma",
        "Neurovascular (Surpass, VectaPlus)",
      ],
      applications: [
        "Total Knee & Hip Arthroplasty",
        "ASC Outpatient Joint Programs",
        "Complex Spine & Deformity",
        "Neurovascular Stroke Care",
      ],
      geographies: [
        "North America (HQ)",
        "Europe (Trauma & Neurovascular)",
        "Asia Pacific (China JV, India R&D)",
        "Latin America & MEA rollout",
      ],
      segments: [
        "Hospitals & IDNs",
        "Ambulatory Surgery Centers",
        "Neurovascular Stroke Centers",
        "Trauma Networks",
      ],
      useCases: [
        "Mako Total Knee same-day discharge",
        "Gamma4 hip fracture fixation",
        "Surpass Streamline flow diversion",
        "Bundled ASC joint programs",
      ],
    },
    jnjmedtech: {
      technologies: [
        "VELYS Digital Surgery",
        "DePuy Synthes Reconstruction",
        "Biosense Webster CARTO/THERMOCOOL",
        "CERENOVUS Stroke Solutions",
      ],
      applications: [
        "Joint Reconstruction (ATTUNE, SIGMA)",
        "Electrophysiology & Cardiac Ablation",
        "Neurovascular Intervention",
        "Robotic & Digital Surgery Pilots",
      ],
      geographies: [
        "North America (scale)",
        "Europe (VELYS rollout)",
        "Asia Pacific (EP & ortho ramp)",
      ],
      segments: [
        "Hospitals & Academic Centers",
        "Cardiology/Electrophysiology Labs",
        "Neurovascular Stroke Centers",
      ],
      useCases: [
        "VELYS-guided TKA",
        "CARTO 3 AF ablation suites",
        "Impella-supported high-risk PCI",
        "CERENOVUS thrombectomy kits",
      ],
    },
    zimmerbiomet: {
      technologies: [
        "ROSA Robotics (Knee/Hip/Shoulder)",
        "Persona IQ Smart Implant",
        "G7 & Avenir Hip Systems",
        "ZBEdge + mymobility analytics",
      ],
      applications: [
        "Primary & Revision Knee",
        "Hip Reconstruction",
        "Shoulder Arthroplasty",
        "Digital Care Management",
      ],
      geographies: [
        "North America",
        "Europe (EMEA hubs)",
        "Asia Pacific (Japan/Australia)",
        "Latin America distributors",
      ],
      segments: [
        "Hospitals & IDNs",
        "Ambulatory Surgery Centers",
        "Orthopedic Specialty Clinics",
      ],
      useCases: [
        "ROSA Knee efficiency programs",
        "Persona IQ remote data capture",
        "G7 dual mobility conversions",
        "mymobility rehab pathways",
      ],
    },
    smithnephew: {
      technologies: [
        "CORI Digital Robotics",
        "Journey II & Legion Knees",
        "RENASES/PICO NPWT",
        "FAST-FIX & REGENETEN Repair",
      ],
      applications: [
        "Sports Medicine & Arthroscopy",
        "Joint Reconstruction",
        "Advanced Wound Care",
        "ENT/COBLATION",
      ],
      geographies: [
        "Europe (HQ)",
        "North America",
        "Asia Pacific (Japan/Australia)",
        "Middle East & Africa distributors",
      ],
      segments: [
        "Hospitals & Health Systems",
        "Ambulatory Surgery Centers",
        "Orthopedic/Sports Clinics",
      ],
      useCases: [
        "REGENETEN rotator cuff augmentation",
        "CORI-enabled outpatient knees",
        "PICO single-use incision management",
        "COBLATION tonsil/adenoid programs",
      ],
    },
    arthrex: {
      technologies: [
        "Synergy UHD4 Visualization",
        "FiberWire/FiberTape Fixation",
        "NanoScope MIS Platforms",
        "ACP/Angel Orthobiologics",
      ],
      applications: [
        "Sports Medicine & Soft Tissue",
        "Orthobiologics & Regenerative Care",
        "Trauma & Distal Extremity",
        "Veterinary Orthopedics",
      ],
      geographies: [
        "North America (Naples HQ)",
        "Europe (Munich hub)",
        "Asia Pacific (Singapore hub)",
        "Latin America (Mexico City)",
      ],
      segments: [
        "Orthopedic/Sports Clinics",
        "Ambulatory Surgery Centers",
        "Veterinary Specialty Hospitals",
      ],
      useCases: [
        "InternalBrace ligament repair",
        "FiberTape cerclage for foot/ankle",
        "NanoScope single-portal arthroscopy",
        "ACP PRP biologic protocols",
      ],
    },
  };

  const companies = [
    { id: "stryker", name: "Stryker" },
    { id: "jnjmedtech", name: "Johnson & Johnson MedTech" },
    { id: "zimmerbiomet", name: "Zimmer Biomet" },
    { id: "smithnephew", name: "Smith & Nephew" },
    { id: "arthrex", name: "Arthrex" },
  ];

  const renderHeatMapItems = (items) => {
    return items.map((item, idx) => {
      const itemKey = item.dataKey || `item-${idx}`;
      const isSelected = selectedHeatMapItem === itemKey;

      return (
        <div key={idx} className="mb-3">
          <div
            className={`heatmap-item bg-${
              item.color
            } bg-opacity-10 border-start border-${
              item.color
            } border-4 p-2 rounded cursor-pointer ${
              isSelected ? "shadow selected-item" : ""
            }`}
            onClick={() => setSelectedHeatMapItem(isSelected ? null : itemKey)}
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div className="flex-grow-1">
                <div className="comp_head_new">{item.name}</div>
                <div className="comp_subhead_new">
                  {item.players} player{item.players > 1 ? "s" : ""} •{" "}
                  {item.players === 4
                    ? "Very crowded"
                    : item.players === 3
                    ? "Competitive"
                    : item.players === 2
                    ? "Moderate"
                    : item.note || "Unique"}
                </div>
                {item.marketSize && (
                  <div className="comp_head_number">{item.marketSize}</div>
                )}
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedDetailModal(itemKey);
                }}
                className="btn btn-sm btn-link p-0 ms-2"
                title="Click for detailed analysis"
                style={{ fontSize: "1.2rem" }}
              >
                <Search size={18} className="text-primary" />
              </button>
            </div>
          </div>

          {isSelected && (
            <div className="mt-2 ms-2 p-3 bg-white rounded border border-primary border-2 shadow-sm">
              <div className="small fw-bold mb-2">
                Companies competing here:
              </div>
              <div className="d-flex flex-wrap gap-1">
                {item.companies.map((company, compIdx) => (
                  <span
                    key={compIdx}
                    className={`badge ${
                      company === "Stryker"
                        ? "bg-primary"
                        : company === "Johnson & Johnson MedTech"
                        ? "bg-danger"
                        : company === "Zimmer Biomet"
                        ? "bg-success"
                        : company === "Smith & Nephew"
                        ? "bg-info"
                        : "bg-warning"
                    }`}
                  >
                    {company}
                  </span>
                ))}
              </div>
              {item.note && (
                <div className="small text-primary fst-italic mt-2">
                  💡 {item.note}
                </div>
              )}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div>
      <style>{`
     
        .selected-item {
          transform: scale(1.05);
        }
        .cursor-pointer {
          cursor: pointer;
        }
        .focus-badge {
          font-size: 0.7rem;
          padding: 0.25rem 0.5rem;
          border-radius: 0.25rem;
          display: inline-block;
          margin: 0.15rem;
        }
        .comp_map_block{
          border-bottom: 1px solid #e9ecef;
          background-color: #fff;
          padding: 12px 16px;
          border: solid 1px #98a4aa33;
          border-radius: 8px;
          margin-bottom: 10px;
        }
        .comp_subhead{
          font-size:13px;
          font-weight:600 !Important;
        }
        .comp_head_new{
          color:#2d343d !important;
          font-size:12px;
          line-height:17.5px;
          font-weight:600;
          margin-bottom:5px;
        }
        .comp_subhead_new{
          color:#64748B !important;
          font-size:12px;
          line-height:17.5px;
          font-weight:400;
          margin-bottom:5px;

        }
        .comp_head_number{
          color:#363b4b !important;
          font-size:13px;
          line-height:17.5px;
          font-weight:600;
        }
        .bg-custom-danger{
          background-color: #fef2f2;
          border-left: 4px solid #b91c1c !important;
        }
        .bg-custom-danger-only{
          background-color: #b91c1c;
        }
        .bg-custom-info{
          background-color: #eff6ff;
          border-left: 4px solid #1e74e6 !important;
        }
        .bg-custom-info-only{
          background-color: #1e74e6;
        }
        .bg-custom-success{
          background-color: #f0fdf4;
          border-left: 4px solid #15803d !important;
        }
        .bg-custom-success-only{
          background-color: #15803d;
        }
        .bg-custom-warning-only{
          background-color: #CFAB69;
        }
        .bg-custom-warning{
          background-color: #feebc89c;
          border-left: 4px solid #CFAB69 !important;
        }
        .score_inter{
          font-weight: 400;
    font-size: 12px;
    background-color: #f0f4fa;
    line-height: 1.4;
    color: rgba(0, 0, 0, 0.6);
    /* margin-top: 5px; */
    margin-bottom: 20px;
    padding: 12px 8px 12px 12px;
    border-radius: 8px;
        }
        .custom-resizable-table-th-content {
          justify-content: unset;
      }
      .custom_highlight_table{
        background-color:#f0f4fa;
      }
        
      `}</style>

      <DetailModal
        selectedDetailModal={selectedDetailModal}
        setSelectedDetailModal={setSelectedDetailModal}
      />

      {/* Competition Heat Map */}
      <div className="card border-0 mb-4 ">
        <div className="card-body comp_map_block">
          <h3 className="exe_summary mb-4">Competition Heat Map</h3>

          <div className="row g-3">
            <div className="col-md-3">
              <div className="d-flex align-items-center gap-2 comp_subhead mb-3">
                <Zap size={16} />
                Technologies
              </div>
              {renderHeatMapItems(heatMapData.technologies)}
            </div>

            <div className="col-md-3">
              <div className="d-flex align-items-center gap-2 comp_subhead fw-bold small mb-3">
                <Box size={16} />
                Applications
              </div>
              {renderHeatMapItems(heatMapData.applications)}
            </div>

            <div className="col-md-3">
              <div className="d-flex align-items-center gap-2 comp_subhead fw-bold small mb-3">
                <Globe size={16} />
                Geographies
              </div>
              {renderHeatMapItems(heatMapData.geographies)}
            </div>

            <div className="col-md-3">
              <div className="d-flex align-items-center gap-2 comp_subhead fw-bold small mb-3">
                <Users size={16} />
                Customer Segments
              </div>
              {renderHeatMapItems(heatMapData.segments)}
            </div>
          </div>

          <div className="row g-2 p-3 bg-light rounded mt-3">
            <div className="col-3 mt-0">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-danger-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold font13">Very Crowded</div>
                  <div className="text-muted font13">4 players</div>
                </div>
              </div>
            </div>
            <div className="col-3 mt-0">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-info-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold font13">Competitive</div>
                  <div className="text-muted font13">3 players</div>
                </div>
              </div>
            </div>
            <div className="col-3 mt-0">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-warning-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold font13">Moderate</div>
                  <div className="text-muted font13">2 players</div>
                </div>
              </div>
            </div>
            <div className="col-3 mt-0">
              <div className="d-flex align-items-center gap-2 small">
                <div
                  className="bg-custom-success-only"
                  style={{ width: "1rem", height: "1rem", borderRadius: "2px" }}
                ></div>
                <div>
                  <div className="fw-bold font13">Unique/Leader</div>
                  <div className="text-muted font13">1 player</div>
                </div>
              </div>
            </div>
          </div>

          <div className="score_inter mt-2 mb-2">
            <div className="d-flex gap-2">
              {/* <Target size={20} className="flex-shrink-0 mt-1" /> */}
              <img src="/img/bullseye.png" width="16" height="16" />
              <div className="small">
                <strong>Strategic Heat Map Insights:</strong> Joint replacement
                ($23.4B) and total knee surgery ($12.0B) remain the largest
                applications but are saturated, demanding superior execution to
                hold share.{" "}
                <strong>
                  CRITICAL: Asia Pacific biomaterials (~$9.7B with the fastest
                  growth) is the must-win geography for the next wave of implant
                  demand.
                </strong>{" "}
                <strong>
                  GREEN OCEANS: Neurovascular stroke centers ($4.6B, two-player
                  field) and ASC digital platforms ($7.2B) provide defendable
                  zones for Stryker to scale premium programs.
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Where Each Company Focuses */}
      <div className="card border-0  mb-4">
        <div className="card-body comp_map_block">
          <h3 className="exe_summary mb-4">Where Each Company Focuses</h3>
          <div className="table-responsive">
            <table className="table custom-resizable-table">
              <thead>
                <tr className="custom-resizable-table-header">
                  <th className="">
                    <div className="custom-resizable-table-th-content">
                      Company
                    </div>
                  </th>
                  <th className="">
                    <div className="d-flex align-items-center gap-1 custom-resizable-table-th-content">
                      <Zap size={14} />
                      Top Technologies
                    </div>
                  </th>
                  <th className="">
                    <div className="d-flex align-items-center gap-1 custom-resizable-table-th-content">
                      <Box size={14} />
                      Top Applications
                    </div>
                  </th>
                  <th className="">
                    <div className="d-flex align-items-center gap-1 custom-resizable-table-th-content">
                      <Globe size={14} />
                      Top Geographies
                    </div>
                  </th>
                  <th className="">
                    <div className="d-flex align-items-center gap-1 custom-resizable-table-th-content">
                      <Users size={14} />
                      Top Segments
                    </div>
                  </th>
                  <th className="">
                    <div className="d-flex align-items-center gap-1 custom-resizable-table-th-content">
                      <Target size={14} />
                      Key Use Cases
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {companies.map((company) => (
                  <tr
                    key={company.id}
                    className={
                      company.id === "stryker"
                        ? "table-primary border-start border-primary border-2 custom_highlight_table"
                        : ""
                    }
                    gtr-row
                  >
                    <td className="gtr-cell">
                      <div className="d-flex align-items-center gap-2">
                        {company.id === "stryker" && (
                          <span className="badge bg-primary">US</span>
                        )}
                        {company.name}
                      </div>
                    </td>
                    <td>
                      <div>
                        {focusAreas[company.id].technologies.map(
                          (tech, techIdx) => (
                            <span
                              key={techIdx}
                              className="focus-badge bg-purple bg-opacity-10 text-dark"
                            >
                              {tech}
                            </span>
                          )
                        )}
                      </div>
                    </td>
                    <td>
                      <div>
                        {focusAreas[company.id].applications.map(
                          (app, appIdx) => (
                            <span
                              key={appIdx}
                              className="focus-badge bg-primary bg-opacity-10 text-dark"
                            >
                              {app}
                            </span>
                          )
                        )}
                      </div>
                    </td>
                    <td>
                      <div>
                        {focusAreas[company.id].geographies.map(
                          (geo, geoIdx) => (
                            <span
                              key={geoIdx}
                              className="focus-badge bg-success bg-opacity-10 text-dark"
                            >
                              {geo}
                            </span>
                          )
                        )}
                      </div>
                    </td>
                    <td>
                      <div>
                        {focusAreas[company.id].segments.map((seg, segIdx) => (
                          <span
                            key={segIdx}
                            className="focus-badge bg-warning bg-opacity-10 text-dark"
                          >
                            {seg}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td>
                      <div>
                        {focusAreas[company.id].useCases.map(
                          (useCase, ucIdx) => (
                            <span
                              key={ucIdx}
                              className="focus-badge bg-danger bg-opacity-10 text-dark"
                            >
                              {useCase}
                            </span>
                          )
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketPosition;